/*
 * @Author: your name
 * @Date: 2020-06-22 18:03:37
 * @Description: In User Settings Edit
 * @FilePath: \web_admin\src\components\index.js
 */
// 方法
import * as filters from '@/utils/allmethods.js'; //全部方法
import { getBusinessList } from '@/service/api/prompt.js';
import { get_dict_name } from '@/service/api/data_dictionary.js';
import { setup_locale } from '@/lang';
import { text_rules } from '@/utils/text_rules';
import deepClone from 'deepclone';
import http from '@/service/httpConfig';
import myConfirm from '@/components/myConfirm/index';
import Message from '@/components/Message/index';
import myVerify from '@/utils/verifyForm/index';
import encrypt from '@/utils/encrypt';
import { auth } from '@/utils/sso'
import Ls from '@/utils/Ls'
import mitt from "mitt";
// 组件
import mrc_ess_addBtn from '@/components/mrc_ess_addBtn.vue';
import mrc_ess_iconGroup from '@/components/mrc_ess_iconGroup';
import mrc_ess_submitBtn from '@/components/mrc_ess_submitBtn.vue';
import mrc_ess_prompt from '@/components/mrc_ess_prompt.vue';
import mrc_ess_skLoaders from '@/components/mrc_ess_skLoaders';
import menuList from '@/components/menuList';
import mrc_ess_colorPicker from '@/components/mrc_ess_colorPicker.vue';
import mrc_ess_dictName from '@/components/mrc_ess_dictName.vue';
import mrc_ess_inputPopUpBox from '@/components/mrc_ess_inputPopUpBox.vue';
import myTree from '@/components/treeList/index';
import mrc_ess_myDialog from '@/components/mrc_ess_myDialog';
import pagination from '@/components/pagination';
import mrc_ess_datePicker from '@/components/mrc_ess_datePicker.vue';
import mrc_ess_myStep from '@/components/mrc_ess_myStep.vue';
import mrc_ess_input from '@/components/mrc_ess_input';
import mrc_ess_multiText from '@/components/mrc_ess_multiText.vue';
import mrc_ess_noContent from '@/components/mrc_ess_noContent.vue';
import mrc_ess_table from '@/components/mrc_ess_table';
import mrc_ess_paginations from '@/components/mrc_ess_paginations.vue';
import mrc_ess_searchInput from '@/components/mrc_ess_searchInput';
import mrc_ess_brandupload from '@/components/mrc_ess_brandupload.vue';
import mrc_ess_tabs from '@/components/mrc_ess_tabs.vue';
import mrc_ess_switch from '@/components/mrc_ess_switch.vue';
import mrc_ess_selectList from '@/components/mrc_ess_selectList.vue';
import mrc_ess_selectStaff from '@/components/mrc_ess_selectStaff.vue';
import mrc_ess_chooseStaff from '@/components/mrc_ess_chooseStaff.vue';
import mrc_ess_fileInput from '@/components/mrc_ess_fileInput.vue';
import mrc_ess_showClientType from '@/components/mrc_ess_showClientType.vue';
import mrc_ess_NumInput from '@/components/mrc_ess_NumInput.vue';
import mrc_ess_phoneInput from '@/components/mrc_ess_phoneInput.vue';
import mrc_ess_importFile from '@/components/mrc_ess_importFile.vue';
import mrc_ess_uploadBtn from '@/components/mrc_ess_uploadBtn.vue';
import mrc_ess_chooseTree from '@/components/mrc_ess_chooseTree.vue';
import mrc_ess_sclectStaffGroup from '@/components/mrc_ess_sclectStaffGroup.vue';
import mrc_ess_autoComplete from '@/components/mrc_ess_autoComplete.vue';
import mrc_ess_advanceFilterAndSearchInput from '@/components/mrc_ess_advanceFilterAndSearchInput/mrc_ess_advanceFilterAndSearchInput.vue';
import mrc_ess_timePicker from '@/components/mrc_ess_timePicker.vue';
import mrc_ess_dateTimePicker from '@/components/mrc_ess_dateTimePicker/mrc_ess_dateTimePicker.vue';
import mrc_ess_taber from '@/components/mrc_ess_taber.vue';
import mrc_ess_yearPicker from '@/components/mrc_ess_yearPicker.vue';
import mrc_ess_autoCompleteEmailTemplate from '@/components/mrc_ess_autoCompleteEmailTemplate.vue';
import mrc_ess_bulkFile from '@/components/mrc_ess_bulkFile.vue';
import mrc_ess_multiTextarea from '@/components/mrc_ess_multiTextarea.vue';
import mrc_ess_paginationsWeb from '@/components/mrc_ess_paginationsWeb.vue';
import mrc_ess_viewbtn from '@/components/mrc_ess_viewbtn.vue';
import mrc_ess_skeleton_loader from '@/components/mrc_ess_skeleton_loader.vue';
import mrc_ess_staffListView from '@/components/mrc_ess_staffListView.vue';
import mrc_ess_staffInfo from '@/components/mrc_ess_staffInfo.vue';
import mrc_ess_textAddBtn from '@/components/mrc_ess_textAddBtn.vue';
import mrc_ess_chip from '@/components/mrc_ess_chip.vue';
import mrc_ess_staffInfo3 from '@/components/mrc_ess_staffInfo3.vue';
import mrc_ess_editor from '@/components/Tinymce/index.vue';

/**
 * 1、addBtn 添加按钮
2、c_s_btns 取消 提交 按钮
3、confirm 二次确认弹窗
4、iconGroup 返回 修改 删除 图标
5、prompt 高级参照下拉框
6、skLoaders 骨架屏
7、menu-list v-menu list
8、mrc_ess_colorPicker 颜色选择器
9、mrc_ess_dictName 普通参照
10、 mrc_ess_mytree 权限列表 员工列表
11、mrc_ess_myDialog 弹窗模板
12、my-pagination 分页器
13、mrc_ess_datePicker 日期选择器
14、mrc_ess_selectStaff 选人
15、mrc_ess_chooseStaff 选人员input+弹出框
 */
/**
 * $http axios请求
 * $text_rules 公用校验rules
 * $clone 深拷贝
 * $setup_locale 设置语言
 * $confirm 弹窗提示
 * $myVerify 校验规则
 *
 */

export default {
  install(Vue) {
    Vue.component('menu-list', menuList);
    Vue.component('mrc_ess_staffInfo3', mrc_ess_staffInfo3);
    Vue.component('mrc_ess_viewbtn', mrc_ess_viewbtn);
    Vue.component('mrc_ess_skeleton_loader', mrc_ess_skeleton_loader);
    Vue.component('my-pagination', pagination);
    Vue.component('mrc_ess_multiText', mrc_ess_multiText);
    Vue.component('mrc_ess_addBtn', mrc_ess_addBtn);
    Vue.component('mrc_ess_iconGroup', mrc_ess_iconGroup);
    Vue.component('mrc_ess_submitBtn', mrc_ess_submitBtn);
    Vue.component('mrc_ess_prompt', mrc_ess_prompt);
    Vue.component('mrc_ess_skLoaders', mrc_ess_skLoaders);
    Vue.component('mrc_ess_colorPicker', mrc_ess_colorPicker);
    Vue.component('mrc_ess_dictName', mrc_ess_dictName);
    Vue.component('mrc_ess_inputPopUpBox', mrc_ess_inputPopUpBox);
    Vue.component('mrc_ess_mytree', myTree);
    Vue.component('mrc_ess_myDialog', mrc_ess_myDialog);
    Vue.component('mrc_ess_datePicker', mrc_ess_datePicker);
    Vue.component('mrc_ess_myStep', mrc_ess_myStep);
    Vue.component('mrc_ess_input', mrc_ess_input);
    Vue.component('mrc_ess_noContent', mrc_ess_noContent);
    Vue.component('mrc_ess_table', mrc_ess_table);
    Vue.component('mrc_ess_paginations', mrc_ess_paginations);
    Vue.component('mrc_ess_searchInput', mrc_ess_searchInput);
    Vue.component('mrc_ess_brandupload', mrc_ess_brandupload);
    Vue.component('mrc_ess_tabs', mrc_ess_tabs);
    Vue.component('mrc_ess_switch', mrc_ess_switch);
    Vue.component('mrc_ess_selectList', mrc_ess_selectList);
    Vue.component('mrc_ess_selectStaff', mrc_ess_selectStaff);
    Vue.component('mrc_ess_chooseStaff', mrc_ess_chooseStaff);
    Vue.component('mrc_ess_fileInput', mrc_ess_fileInput);
    Vue.component('mrc_ess_NumInput', mrc_ess_NumInput);
    Vue.component('mrc_ess_showClientType', mrc_ess_showClientType);
    Vue.component('mrc_ess_phoneInput', mrc_ess_phoneInput);
    Vue.component('mrc_ess_importFile', mrc_ess_importFile);
    Vue.component('mrc_ess_uploadBtn', mrc_ess_uploadBtn);
    Vue.component('mrc_ess_chooseTree', mrc_ess_chooseTree);
    Vue.component('mrc_ess_sclectStaffGroup', mrc_ess_sclectStaffGroup);
    Vue.component('mrc_ess_autoComplete', mrc_ess_autoComplete);
    Vue.component(
      'mrc_ess_advanceFilterAndSearchInput',
      mrc_ess_advanceFilterAndSearchInput
    );
    Vue.component('mrc_ess_timePicker', mrc_ess_timePicker);
    Vue.component('mrc_ess_dateTimePicker', mrc_ess_dateTimePicker);
    Vue.component('mrc_ess_taber', mrc_ess_taber);
    Vue.component('mrc_ess_yearPicker', mrc_ess_yearPicker);
    Vue.component(
      'mrc_ess_autoCompleteEmailTemplate',
      mrc_ess_autoCompleteEmailTemplate
    );
    Vue.component('mrc_ess_bulkFile', mrc_ess_bulkFile);
    Vue.component('mrc_ess_multiTextarea', mrc_ess_multiTextarea);
    Vue.component('mrc_ess_paginationsWeb', mrc_ess_paginationsWeb);
    Vue.component('mrc_ess_staffListView', mrc_ess_staffListView);
    Vue.component('mrc_ess_staffInfo', mrc_ess_staffInfo);
    Vue.component('mrc_ess_textAddBtn', mrc_ess_textAddBtn);
    Vue.component('mrc_ess_chip', mrc_ess_chip);
    Vue.component('mrc_ess_editor', mrc_ess_editor);

    Vue.prototype.$http = http;
    Vue.prototype.$sso_auth = auth;
    Vue.prototype.$ls = Ls;
    Vue.prototype.$mitt = mitt();
    Vue.prototype.$text_rules = text_rules;

    Vue.prototype.$getBusinessList = getBusinessList;
    Vue.prototype.$getDictName = get_dict_name;
    // Vue.prototype.$clone = deepClone
    Vue.prototype.$clone = (val) => JSON.parse(JSON.stringify(val));
    Vue.prototype.$setup_locale = setup_locale;
    Vue.prototype.$myConfirm = myConfirm.install;
    // Vue.prototype.$Message = Message.install
    Vue.prototype.$Message = Message;
    Vue.prototype.$myVerify = myVerify;
    Vue.prototype.$encrypt = encrypt;
    Object.keys(filters).forEach((key) => {
      Vue.prototype[key] = filters[key]; //插入方法名和对应方法
    });
  },
};
